import { Injectable, inject } from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Store} from '@ngrx/store';
import {catchError, map, switchMap} from 'rxjs/operators';
import {of} from 'rxjs';
import {LoaderService} from '@app/services/loader.service';
import {
  TemplateSectionTypeList,
  TemplateSectionTypeListSuccess,
  TemplateSectionTypeListError,
  TemplateSectionListAll,
  TemplateSectionListAllSuccess,
  TemplateSectionListAllError
} from '@app/stores/template-section/template-section.actions';
import {ITemplateSectionState} from '@app/stores/template-section/template-section.state';
import {TemplateSectionService} from '@app/services/template-section.service';

@Injectable()
export class TemplateSectionEffects {
  private _actions$ = inject(Actions);
  private _store = inject<Store<ITemplateSectionState>>(Store);
  private templateSectionService = inject(TemplateSectionService);
  private loaderService = inject(LoaderService);


  templateSectionListAll$ = createEffect(() => this._actions$.pipe(
    ofType(TemplateSectionListAll),
    switchMap((action) => {
      this.loaderService.show();
      return this.templateSectionService.list(action.params).pipe(
        map((resp: any) => {
          if (resp.success) {
            this.loaderService.hide();
            return TemplateSectionListAllSuccess({templateSections: resp.data});
          }
          this.loaderService.hide(true);
          return TemplateSectionListAllError({error: this.loaderService.getErrorMessage(resp)});
        }),
        catchError(error => {
          this.loaderService.hide(true);
          return of(TemplateSectionListAllError({error: this.loaderService.getErrorMessage(error)}));
        })
      );
    })
  ));

  templateSectionTypeList$ = createEffect(() => this._actions$.pipe(
    ofType(TemplateSectionTypeList),
    switchMap((action) => {
      this.loaderService.show();
      return this.templateSectionService.listSectionTypes(action.params).pipe(
        map((resp: any) => {
          if (resp.success) {
            this.loaderService.hide();
            return TemplateSectionTypeListSuccess({templateSectionTypes: resp.data});
          }
          this.loaderService.hide(true);
          return TemplateSectionTypeListError({error: this.loaderService.getErrorMessage(resp)});
        }),
        catchError(error => {
          this.loaderService.hide(true);
          return of(TemplateSectionTypeListError({error: this.loaderService.getErrorMessage(error)}));
        })
      );
    })
  ));
}
